import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import ModalLayout from '../../../../ModalLayout';
import ModalFooter from '../../../../ModalFooter';
import s from './HorizontalLayout.scss';
var HorizontalLayout = function (_a) {
    var title = _a.title, message = _a.message, image = _a.image, className = _a.className, footerLeft = _a.footerLeft, footerRight = _a.footerRight, rest = __rest(_a, ["title", "message", "image", "className", "footerLeft", "footerRight"]);
    return (React.createElement(ModalLayout, __assign({ className: c(s['root'], className), footer: React.createElement(ModalFooter, { left: footerLeft, right: footerRight }), content: React.createElement("div", { className: s['content-root'] },
            image && React.createElement("div", { className: s['image'] }, image),
            React.createElement("div", { className: s['title'] }, title),
            React.createElement("div", { className: s['message'] }, message)) }, rest)));
};
HorizontalLayout.displayName = 'HorizontalLayout';
export default HorizontalLayout;
//# sourceMappingURL=HorizontalLayout.js.map